export const PRICING_USAGE_CONTEXT = "gold_pricing";
export const HOLOGRAM_PAGE_USAGE_CONTEXT = "hologram_page";
export const COIN_CARD_PRICE_MULTIPLIER = 1.1;
export const COIN_COUNT_STEP = 9;

export function getProductionQuantity(quantity, productType = "coin") {
  const total = Math.max(0, Math.floor(Number(quantity) || 0));
  return productType === "coin" ? Math.ceil(total / COIN_COUNT_STEP) * COIN_COUNT_STEP : total;
}

export function formatBatchQuantity(quantity) {
  const total = Number(quantity) || 0;
  if (total >= 1000000 && total % 1000000 === 0) return `${(total / 1000000).toLocaleString("fa-IR")} میلیون`;
  if (total >= 1000 && total % 1000 === 0) return `${(total / 1000).toLocaleString("fa-IR")} هزار`;
  return total.toLocaleString("fa-IR");
}

export function splitCoinCountsByQuantity(quantity) {
  const safeQuantity = getProductionQuantity(quantity) / COIN_COUNT_STEP;
  const base = Math.floor(safeQuantity / 3);
  const remainder = safeQuantity % 3;

  return {
    full: (base + (remainder >= 1 ? 1 : 0)) * COIN_COUNT_STEP,
    half: (base + (remainder >= 2 ? 1 : 0)) * COIN_COUNT_STEP,
    quarter: base * COIN_COUNT_STEP,
  };
}

// Largest-remainder allocation preserves the customer's mix and the exact total.
export function resizeCoinCounts(current, quantity) {
  const keys = ["full", "half", "quarter"];
  const total = keys.reduce((sum, key) => sum + Math.max(0, Number(current[key]) || 0), 0);
  if (!Number.isFinite(total) || total <= 0) return splitCoinCountsByQuantity(quantity);
  const target = getProductionQuantity(quantity) / COIN_COUNT_STEP;
  const shares = keys.map((key) => Math.max(0, Number(current[key]) || 0) / total * target);
  const counts = shares.map(Math.floor);
  const ranked = keys.map((_, index) => index).sort((a, b) => (shares[b] - counts[b]) - (shares[a] - counts[a]));
  for (let n = target - counts.reduce((a, b) => a + b, 0), i = 0; i < n; i++) counts[ranked[i % keys.length]]++;
  return Object.fromEntries(keys.map((key, index) => [key, counts[index] * COIN_COUNT_STEP]));
}

export function validatePricingSelection(selection, quantity) {
  if (!Number.isSafeInteger(quantity) || quantity <= 0) return "تیراژ معتبر انتخاب کنید.";
  if (selection.product_type === "coin") {
    const values = ["full", "half", "quarter"].map((key) => Number(selection.coin_counts?.[key] ?? 0));
    if (values.some((value) => !Number.isSafeInteger(value) || value < 0)) return "تعداد هر نوع سکه باید عدد صحیح و نامنفی باشد.";
    if (values.some((value) => value % COIN_COUNT_STEP !== 0)) return "تعداد هر نوع سکه باید مضرب ۹ باشد؛ مانند ۹، ۱۸ یا ۲۷.";
    if (values.reduce((a, b) => a + b, 0) !== getProductionQuantity(quantity)) return "مجموع تعداد سکه‌ها باید با تعداد واقعی تولید برابر باشد.";
  }
  const colors = Number(selection.security_color_count ?? 0);
  if (!Number.isInteger(colors) || colors < 0 || colors > 4) return "تعداد رنگ اضافه باید عدد صحیح بین صفر و چهار باشد.";
  if (selection.product_type === "parsian_plate" && selection.parsian_option === "variable_label") {
    const tolerance = Number(selection.parsian_weight_tolerance);
    if (!Number.isFinite(tolerance) || tolerance < 0) return "تلورانس وزن را به‌صورت عدد نامنفی وارد کنید.";
  }
  return "";
}

export function getPricingUnitPriceForProductType(unitPriceToman, productType) {
  const safeUnitPrice = Number(unitPriceToman || 0);
  if (productType === "coin") {
    return Math.round(safeUnitPrice * COIN_CARD_PRICE_MULTIPLIER);
  }
  return safeUnitPrice;
}

export function normalizeHologramSizeSelection(currentSize, sizes = []) {
  const firstSize = sizes[0]?.size || "";
  if (!currentSize) return firstSize;
  return sizes.some((item) => item.size === currentSize) ? currentSize : firstSize;
}
